import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 33.5px 24px 49.5px 88px;
  width: 100%;
  background: ${colors.white};
  border-radius: 4px;
  margin-bottom: 16px;
  @media ${device.mobileMax} {
    padding: 33.5px 24px 49.5px;
  }
`

export const SelectTitle = styled.div`
  display: flex;
  line-height: 21px;
  justify-content: space-between;
  font-size: 14px;
  color: ${colors.mainText};
  font-weight: 400;
  margin-bottom: 16px;
  @media (min-width: 576px) {
    margin-bottom: 8px;
  }
`

export const WrapperRelative = styled.div`
  position: relative;
`

export const WrapperRelativeLanguages = styled.div`
  position: relative;
  margin-bottom: 14px;
`

export const WrapperForLanguageCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  color: ${colors.mainText};
  line-height: 21px;
  font-size: 14px;
`

export const NeedHelpButton = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 43px;
  width: fit-content;
  font-size: 14px;
  color: ${colors.mainText};
  border-bottom: 1px dashed ${colors.mainText};
  cursor: pointer;
`

export const CenteredBlock = styled.div`
  margin: 0 auto;
`

export const HintModal = styled.div<{ languages?: boolean }>`
  position: absolute;
  padding: 26px 24px;
  color: #646877;
  background: #fff;
  font-size: 14px;
  line-height: 1;
  z-index: 100;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 320px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  transform: translate(50%, -50%);
  right: 215px;
  top: ${({ languages }) => (languages ? `48%` : `18%`)};
`
